/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { IButtonProps, IButtonStyles, PrimaryButton } from '@fluentui/react/lib/Button';
import { classNamesFunction } from '@fluentui/react/lib/Utilities';
import * as React from 'react';
import { getScopedTheme } from 'src/core/themes/luisStylist';
import { lightenOrDarkenColor } from 'src/core/utils/color';

const deleteButtonTheme = getScopedTheme('DeleteButton');

const getClassNames = classNamesFunction<IButtonProps, IButtonStyles>();
const deleteButtonStyles = getClassNames({
    root: {
        backgroundColor: deleteButtonTheme.backgroundColor,
        border: 'none'
    },
    rootHovered: { backgroundColor: deleteButtonTheme.hoverBackgroundColor, border: 'none' },
    rootPressed: { backgroundColor: lightenOrDarkenColor(deleteButtonTheme.activeBackgroundColor, -25), border: 'none' }
});

/**
 * Represents a delete button to be used in any
 * deletion prompt or deletion control.
 */
export const DeleteButton = (props: IButtonProps) => <PrimaryButton {...props} styles={deleteButtonStyles} />;
